export const hrDiscountsColumns = [
    {
        headerName: "Discount",
        field: "discount",
        width: 160,
    },
    {
        headerName: "Description",
        field: "description",
        width: 160,
    },
    {
        headerName: "Bill Amount",
        field: "billAmount",
        width: 160
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "clientNumber",
        headerName: "User Contact No.",
        width: 160,
    },
    {
        field: "status",
        headerName: "Status",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];